<template>
    <div>
        <label class="label" v-if="label">{{ label }}</label>
        <div
            :class="{ '-border-hidden': !border }"
            @click="modalVisible = true"
            class="sidebar-button"
        >
            {{ dateDisplay }}
        </div>
        <transition name="fade">
            <div class="popup-wrap" v-if="modalVisible">
                <div class="popup-modal" @click="close"></div>
                <div class="popup-content">
                    <div>
                        <div class="datepicker-navigation">
                            <div
                                class="sidebar-button -icon"
                                style="margin-left: 0"
                                @click="changeMonth('subtract')"
                            >
                                <i class="material-icons">{{
                                    'chevron_left'
                                }}</i>
                            </div>
                            <MonthPicker v-model="currentMonth" />
                            <div
                                class="sidebar-button -icon"
                                @click="changeMonth('add')"
                            >
                                <i class="material-icons">{{
                                    'chevron_right'
                                }}</i>
                            </div>
                        </div>
                        <div class="parent-calendar-header">
                            <div
                                class="parent-calendar-weekday"
                                v-for="day in weekdays"
                                :key="day"
                            >
                                {{ day }}
                            </div>
                        </div>
                        <transition-group
                            tag="div"
                            name="list"
                            class="parent-calendar-cells"
                        >
                            <div
                                class="parent-calendar-cell"
                                :key="cell"
                                v-for="cell in cells"
                            >
                                <div
                                    v-if="cellDisplay(cell)"
                                    class="parent-calendar-cell-day"
                                    :class="cellClass(cell)"
                                    @click="selectDate(cell)"
                                >
                                    {{ cellDisplay(cell) }}
                                </div>
                            </div>
                        </transition-group>
                    </div>
                    <div style="text-align: center; margin-top: 2rem">
                        <ActionButton @click="submit" :label="$t('APPLY')" />
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    components: {
        MonthPicker: () => import('./MonthPicker')
    },
    props: {
        label: String,
        title: String,
        type: {
            type: String,
            default: 'single'
        },
        border: {
            type: Boolean,
            default: true
        },
        value: [String, Object, Array]
    },
    data() {
        return {
            weekdays: this.$moment.weekdaysShort(true),
            cells: 37,
            selectedDates: [],
            currentMonth: this.$moment().format('YYYY-MM'),
            currentDate: this.$moment().format('YYYY-MM-DD'),
            firstDate: '',
            lastDate: '',
            modalVisible: false
        }
    },
    computed: {
        dateDisplay() {
            switch (this.type) {
                case 'single':
                    return this.value
                        ? this.value
                        : this.$t('LABEL_EMPTY_COMMENT')
                case 'multi':
                    return this.value[0]
                        ? `${this.$moment(this.value[0]).format(
                              'D MMMM YYYY'
                          )}...`
                        : this.$t('LABEL_EMPTY_COMMENT')
                case 'range':
                    return this.value.start && this.value.end
                        ? `${this.$moment(this.value.start).format(
                              'D MMMM YYYY'
                          )} - ${this.$moment(this.value.end).format(
                              'D MMMM YYYY'
                          )}`
                        : this.title
                          ? this.title
                          : this.$t('LABEL_EMPTY_COMMENT')
                case 'set':
                    return this.value.length > 0
                        ? `${this.$moment(this.value[0]).format(
                              'D MMMM YYYY'
                          )} - ${this.$moment(
                              this.value[this.value.length - 1]
                          ).format('D MMMM YYYY')}`
                        : this.$t('LABEL_EMPTY_COMMENT')
            }
        },
        offset() {
            return this.$moment(this.currentMonth).startOf('month').weekday()
        },
        daysInMonth() {
            return this.$moment(this.currentMonth).daysInMonth()
        }
    },
    methods: {
        close() {
            this.modalVisible = false
            this.setInitDate()
        },
        createRange() {
            let currentDate = this.firstDate
            while (this.$moment(currentDate).isBefore(this.lastDate)) {
                currentDate = this.$moment(currentDate)
                    .add(1, 'days')
                    .format('YYYY-MM-DD')
                this.selectedDates.push(currentDate)
            }
        },
        selectMultipleDates(cellDate) {
            const index = this.selectedDates.indexOf(cellDate)
            index == -1
                ? this.selectedDates.push(cellDate)
                : this.selectedDates.splice(index, 1)
        },
        selectSet(cellDate) {
            switch (true) {
                case !this.firstDate ||
                    this.$moment(cellDate).isBefore(this.firstDate):
                    this.firstDate = cellDate
                    this.lastDate = ''
                    this.selectedDates = [cellDate]
                    break
                case !this.lastDate:
                    this.lastDate = cellDate
                    this.createRange()
                    break
                case this.$moment(this.firstDate).isBefore(cellDate) &&
                    this.$moment(cellDate).isBefore(this.lastDate):
                    const index = this.selectedDates.indexOf(cellDate)
                    index == -1
                        ? this.selectedDates.push(cellDate)
                        : this.selectedDates.splice(index, 1)
                    break
                default:
                    this.firstDate = cellDate
                    this.lastDate = ''
                    this.selectedDates = [cellDate]
                    break
            }
        },
        selectRange(cellDate) {
            switch (true) {
                case !this.firstDate ||
                    this.$moment(cellDate).isBefore(this.firstDate):
                    this.firstDate = cellDate
                    this.lastDate = ''
                    this.selectedDates = [cellDate]
                    break
                case !this.lastDate:
                    this.lastDate = cellDate ? cellDate : null
                    this.createRange()
                    break
                default:
                    this.firstDate = cellDate
                    this.lastDate = ''
                    this.selectedDates = [cellDate]
                    break
            }
        },
        submit() {
            switch (this.type) {
                case 'single':
                    if (!this.selectedDates[0]) {
                        return
                    }
                    this.$emit('input', this.selectedDates[0])
                    break
                case 'set':
                    this.$emit('input', this.selectedDates)
                    break
                case 'range':
                    if (this.selectedDates.length <= 1) {
                        return
                    }
                    this.$emit('input', {
                        start: this.selectedDates[0],
                        end: this.selectedDates[this.selectedDates.length - 1]
                    })
                    break
                case 'multi':
                    this.$emit('input', this.selectedDates)
                    break
            }
            this.close()
        },
        selectSingleDate(cellDate) {
            this.selectedDates = [cellDate]
        },
        selectDate(cell) {
            const cellDate = this.getCellDate(cell)
            switch (this.type) {
                case 'single':
                    this.selectSingleDate(cellDate)
                    break
                case 'range':
                    this.selectRange(cellDate)
                    break
                case 'set':
                    this.selectSet(cellDate)
                    break
                case 'multi':
                    this.selectMultipleDates(cellDate)
                    break
            }
        },
        changeMonth(direction) {
            this.currentMonth =
                direction == 'add'
                    ? this.$moment(this.currentMonth)
                          .add(1, 'months')
                          .format('YYYY-MM')
                    : this.$moment(this.currentMonth)
                          .subtract(1, 'months')
                          .format('YYYY-MM')
        },
        getCellDate(cell) {
            const cellValue = cell - this.offset
            const dayValue = cellValue < 10 ? `0${cellValue}` : cellValue
            return this.$moment(`${this.currentMonth}-${dayValue}`).format(
                'YYYY-MM-DD'
            )
        },
        cellClass(cell) {
            let classes = []
            const cellDate = this.getCellDate(cell)
            if (cellDate == this.$moment().format('YYYY-MM-DD')) {
                classes.push('-today')
            }
            if (this.$store.state.freeDays.some(day => day == cellDate)) {
                classes.push('-free')
            }
            if (this.selectedDates.some(day => day == cellDate)) {
                classes.push('-selected')
            }
            return classes.join(' ')
        },
        cellDisplay(cell) {
            if (cell > this.offset && cell <= this.daysInMonth + this.offset) {
                return cell - this.offset
            }
        },
        setInitDate() {
            switch (this.type) {
                case 'single':
                    if (this.value) {
                        this.currentDate = this.$moment(this.value).format(
                            'YYYY-MM-DD'
                        )
                        this.currentMonth = this.$moment(this.value).format(
                            'YYYY-MM'
                        )
                        this.selectedDates = [this.value]
                    }
                    break
                case 'multi':
                    if (this.value) {
                        this.currentDate = this.value[0]
                        this.currentMonth = this.$moment(this.value[0]).format(
                            'YYYY-MM'
                        )
                        this.selectedDates = this.value
                    }
                    break
                case 'range':
                    if (this.value.start && this.value.end) {
                        this.selectedDates = []
                        this.currentDate = this.value.start
                        this.currentMonth = this.$moment(
                            this.value.start
                        ).format('YYYY-MM')
                        this.firstDate = this.$moment(this.value.start)
                            .subtract(1, 'days')
                            .format('YYYY-MM-DD')
                        this.lastDate = this.value.end ? this.value.end : null
                        this.createRange()
                    }
                    break
                case 'set':
                    if (this.value) {
                        this.currentDate = this.value[0]
                        this.currentMonth = this.$moment(this.value[0]).format(
                            'YYYY-MM'
                        )
                        this.selectedDates = JSON.parse(
                            JSON.stringify(this.value)
                        )
                    }
                    break
            }
        }
    },
    watch: {
        value() {
            this.setInitDate()
        }
    },
    mounted() {
        this.setInitDate()
    }
}
</script>
<style lang="scss" scoped>
.popup-content {
    padding: 1rem;
    box-sizing: border-box;
    width: 30% !important;

    @media (max-width: 1000px) {
        width: 100% !important;
    }
}
.datepicker-navigation {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1.5rem;
    margin-bottom: 1rem;
}
.sidebar-button {
    white-space: nowrap;
    &.-border-hidden {
        border: none;
        min-height: 0;
    }
}
.label {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
}
.parent-calendar-header {
    display: flex;
    align-items: center;
    font-family: $input-family;
    width: 100%;
}
.parent-calendar-weekday {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
}
.parent-calendar-cells {
    margin-top: 0.5rem;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
}
.parent-calendar-cell {
    width: calc(100% / 7);
    height: calc(100% / 6);
    min-height: calc(100% / 6);
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    user-select: none;
}
.parent-calendar-cell-day {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    height: 2.5rem;
    width: 2.5rem;
    cursor: pointer;
    transition:
        ease box-shadow 0.3s,
        background ease 0.3s;
    font-family: $input-family;
    font-size: 0.8rem;
    box-sizing: border-box;
    margin: 0.2rem;

    @media (max-width: 1400px) {
        height: 1.5rem;
        width: 1.5rem;
        font-size: 0.6rem;
    }

    &:hover {
        box-shadow: $minimal-shadow;
    }

    &.-selected {
        color: #fff;
        background: $accent-yellow;
    }
    &.-today {
        border: solid 0.2rem $accent-purple;
    }
    &.-free {
        color: #fff;
        background: $accent-grey;
    }
    &.-absent {
        color: #fff;
        background: $accent-red;
    }
    &.-present {
        color: #fff;
        background: $accent-apple;
    }
    &.-planned {
        color: #fff;
        background: $accent-blue;
    }
    &.-meals {
        border: solid 0.2rem $accent-orange;
    }
}

.sidebar-button {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: $input-border;
    padding: 0.4rem 0.5rem;
    box-sizing: border-box;
    border-radius: $small-radius;
    min-height: 2.5rem;
    font-size: 0.9rem;
    font-family: $input-family;
    margin-left: 1rem;
    cursor: pointer;
    transition: $ease;
    user-select: none;

    &.-icon {
        justify-content: center;

        @media (max-width: 1400px) {
            min-height: 2rem;
            font-size: 0.5rem;
            padding: 0;
        }
    }

    &:hover {
        border-color: $main-accent;
    }
}
</style>
